export default __webpack_public_path__ + "static/media/education_savings_account_dark.037fdd82.png";